import axios from 'axios';
import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { Col, Row, Container, Tabs, Tab, Spinner, Stack, Accordion, Button, Alert } from 'react-bootstrap';
import { BsTags, BsClock, BsReply, BsChatText, BsFileEarmarkText, BsFileEarmarkExcel, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import TicketSidePanel from './TicketSidePanel';
import TicketDetailsSkeleton from './TicketDetailsSkeleton';

import Time from "../../Time";
import TimerWatch from './TicketTimer';

import MainContainer from "../../../MainContainer";
import Comment from './Comment';
import Conversations from './Conversations';
import ActivityModal from './ActivityModal';
import TicketProperties from './TicketProperties';
import { TicketActions } from './TicketActions';
import TransferTicketModal from './TransferTicketModal';
import { baseURL } from "../../../../helpers/baseURL";
import { headers } from '../../../../helpers/Requests';
import { formatDateOnly } from '../../../../helpers/formatDate';
import useEchoUpdateTicket from '../customHooks/useEchoUpdateTicket';
import useEchoCommentSeen from '../customHooks/useEchoCommentSeen';
import { useSelector, useDispatch } from 'react-redux';
import LinkTask from '../ticket-components/LinkTask';
import CreateTask from '../ticket-components/CreateTask';
import { Link } from 'react-router-dom';
import tableStyles from '../TicketsTable.module.css';
import { IoMdEye } from 'react-icons/io';
import ticketDetailsStyles from './TicketDetails.module.css';
import Tasks from '../../Tasks';
import { ModalProvider, ModalContext, ModalRoot } from 'react-multi-modal';
import { fetchTasks, postMarkSeenTickets, deleteTask } from '../../../../redux/actions';
import { set } from 'lodash';
import moment from 'moment';
import { IoIosLink, IoMdTrash, IoMdAdd } from 'react-icons/io';
import { confirmAlert } from 'react-confirm-alert';
import Cookies from 'js-cookie';
import successAlert from '../../../../helpers/successAlert';
import failAlert from '../../../../helpers/failAlert';

function LinkedClaritaskTab({ ticketId, tasks, tasksLoading, showClaritaskCreate, showClaritaskLink, user }) {
    const dispatch = useDispatch();

    const deleteTaskFunc = (claritask_task_id) => {
        confirmAlert({
            title: 'Are you sure you want to delete this task?',
            message: 'This task will be deleted in Claritask too.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        axios.post(`${baseURL}delete-ticket-task/${ticketId}`, { claritask_task_id }, {
                            headers: { Authorization: `Bearer ${Cookies.get('access_token')}` }
                        }).then(() => dispatch(deleteTask(claritask_task_id)))
                          .then(successAlert('Task deleted'))
                          .catch((error) => failAlert(error.response?.data?.message || 'Something went wrong. Please try again later.'));
                    }
                },
                { label: 'No', onClick: () => {} }
            ],
            overlayClassName: 'confirm-overlay'
        });
    };

    const unlinkTask = (claritask_task_id) => {
        confirmAlert({
            title: 'Are you sure you want to unlink this task?',
            message: 'This task will be unlinked from the ticket.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        axios.post(`${baseURL}unlink-ticket/${ticketId}`, { claritask_task_id }, {
                            headers: { Authorization: `Bearer ${Cookies.get('access_token')}` }
                        }).then(() => dispatch(deleteTask(claritask_task_id)))
                          .then(successAlert('Task unlinked'))
                          .catch((error) => failAlert(error.response?.data?.message || 'Something went wrong. Please try again later.'));
                    }
                },
                { label: 'No', onClick: () => {} }
            ],
            overlayClassName: 'confirm-overlay'
        });
    };

    if (!user?.activeApp) {
        return (
            <div className="linked-claritask-empty">
                <img src="/images/claritasklogo.svg" alt="claritask" style={{ width: 32, height: 32, opacity: 0.4 }} />
                <p className="mt-2 text-muted">Claritask is not connected.</p>
                <Link to="/settings/connect_cc" className="btn btn-sm btn-outline-primary mt-1">Integrate Claritask</Link>
            </div>
        );
    }

   return (
    <ModalProvider>
        <ModalContext.Consumer>
            {({ showModal }) => (
                <>
                    {tasksLoading ? (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner animation="border" size="sm" />
                        </div>
                    ) : (
                        <div className="linked-claritask-grid">
                            {tasks && tasks.map(task => (
                                <div
                                    key={`grid-task-${task.task_id}`}
                                    className="claritask-card"
                                    onClick={() => window.open(task?.task_link ?? '#', '_blank')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="claritask-card-meta">
                                        <img src="/images/claritasklogo.svg" alt="claritask" className="claritask-card-logo" />
                                        <a
                                            href={task?.project_link ?? '#'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="claritask-card-project"
                                            title={task.project_name}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {task.project_name || 'Claritask'}
                                        </a>
                                    </div>

                                    <a
                                        href={task?.task_link ?? '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="claritask-card-title"
                                        title={task.task_text}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {task.task_text}
                                    </a>

                                    <div className="claritask-card-footer">
                                        <div className="claritask-card-assignees">
                                            {task.task_people_assigns?.slice(0, 3).map(u => (
                                                <span
                                                    key={u.user_id}
                                                    className="claritask-card-avatar"
                                                    data-fullname={`${u.first_name} ${u.last_name}`}
                                                >
                                                    {u.first_name?.[0]}
                                                    {u.last_name?.[0]}
                                                </span>
                                            ))}
                                        </div>
                                        <div className="claritask-card-dates-row">
                                            {Number(task.task_due_date) > 0 && (
                                                <span
                                                    className={`claritask-card-due-badge${moment.unix(Number(task.task_due_date)).isBefore(moment()) ? ' claritask-card-due-badge--overdue' : ''}`}
                                                    data-label="Due date"
                                                >
                                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                                                        <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                                    </svg>
                                                    {formatDateOnly(Number(task.task_due_date) * 1000)}
                                                </span>
                                            )}
                                            {Number(task.task_created_date) > 0 && (
                                                <span className="claritask-card-created-badge" data-label="Created">
                                                    {formatDateOnly(Number(task.task_created_date))}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="claritask-card-actions">
                                         <button
                                            className={tableStyles.actionBtn}
                                            title="View task"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                // Option 1: open task link
                                                window.open(task?.task_link, '_blank');

                                                // Option 2 (if you want modal later)
                                                // showTaskPreview(task);
                                            }}
                                        >
                                            <IoMdEye size={12} />
                                        </button>
                                        {task.claritick_status != 1 && (
                                            <button
                                                className={tableStyles.actionBtn}
                                                title="Unlink task"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    unlinkTask(task.task_id);
                                                }}
                                            >
                                                <IoIosLink size={12} />
                                            </button>
                                        )}

                                        <button
                                            className={tableStyles.actionBtn}
                                            title="Delete task"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                deleteTaskFunc(task.task_id);
                                            }}
                                        >
                                            <IoMdTrash size={12} />
                                        </button>
                                    </div>
                                </div>
                            ))}

                            <div className="claritask-card-group">
                                <div
                                    className="claritask-card claritask-card--add"
                                    onClick={() => showClaritaskCreate(showModal)}
                                >
                                    <IoMdAdd className="claritask-card-add-icon" />
                                    <span className="claritask-card-add-label">Create New Task</span>
                                </div>

                                <div
                                    className="claritask-card claritask-card--link"
                                    onClick={() => showClaritaskLink(showModal)}
                                >
                                    <IoIosLink className="claritask-card-add-icon" />
                                    <span className="claritask-card-add-label">Link Existing Task</span>
                                </div>
                            </div>
                        </div>
                    )}
                    <ModalRoot />
                </>
            )}
        </ModalContext.Consumer>
    </ModalProvider>
);
}

function TicketDetails() {
    useEchoUpdateTicket();
    const history = useHistory();
    const { id: ticketId } = useParams();
    const ticketIdRef = useRef(ticketId);
    ticketIdRef.current = ticketId;

    const handleCommentSeen = useCallback((e) => {
        setTicket(prev => {
            if (!prev) return prev;
            const type = e.type;
            const existing = Array.isArray(prev.comment_seens?.[type]) ? prev.comment_seens[type] : [];
            const updated = [
                ...existing.filter(entry => entry.user?.id !== e.user?.id),
                { user: e.user, last_seen_comment_id: e.lastSeenCommentId, seen_at: e.seenAt },
            ];
            return {
                ...prev,
                comment_seens: { ...(prev.comment_seens || {}), [type]: updated },
            };
        });
    }, []);
    useEchoCommentSeen(ticketId, handleCommentSeen);
    const mainColRef = useRef(null);
    const [showPanel, setShowPanel] = useState(() => localStorage.getItem('ticketSidePanel') === 'true');
    const [sidePanelTicketUpdate, setSidePanelTicketUpdate] = useState(null);
    const togglePanel = (val) => {
        localStorage.setItem('ticketSidePanel', val);
        setShowPanel(val);
    };
    const [reports, setReports] = useState([]);
    const [ticket, setTicket] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [ticketFound, setTicketFound] = useState(true);
    const [activeKey, setActiveKey] = useState('reply');
    const [key, setKey] = useState('note');
    const dispatch = useDispatch();

    const user = useSelector(state => state?.userReducer?.user);
    const tasks = useSelector(state => state.allTasks?.tasks);
    const tasksTicketId = useSelector(state => state.allTasks?.ticketId);
    const tasksLoading = useSelector(state => state.allTasks?.loading ?? true);
    const tasksMatchTicket = String(tasksTicketId) === String(ticketId);
    const tmpTasks = tasksMatchTicket ? (tasks?.tasks ?? []) : [];
    const linkedTasksLoading = tasksLoading || !tasksMatchTicket;
    const isCustomer = user?.isCustomer || user?.is_customer;
    const isAdmin = user?.isAdmin || user?.is_admin;
    const isTransferredOut = !!ticket?.is_transferred_out;
    const statusName = String(ticket?.status?.name ?? "").toLowerCase();
    const isRejected = !!ticket?.is_rejected || statusName === "rejected";
    const isClosedTicket =
        !!ticket?.is_closed || statusName === "closed";
    const isClosed =
        isTransferredOut ||
        isClosedTicket ||
        isRejected ||
        !!ticket?.is_locked;

    const [claritaskComments, setClaritaskComments] = useState([]);
    const [loadingClaritask, setLoadingClaritask] = useState(true);
    const [sendingClarification, setSendingClarification] = useState(false);
    const [sendingConfirmation, setSendingConfirmation] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);

    useEffect(() => {
        const fetchClaritaskComments = async () => {
            if (!ticket || String(ticket.id) !== String(ticketId)) return;
            if (ticket.is_transferred_out) {
                setClaritaskComments([]);
                setLoadingClaritask(false);
                return;
            }
            const requestedId = ticketId;
            try {
                setLoadingClaritask(true);
                const res = await axios.get(`${baseURL}tickets/${requestedId}/claritask-comments`, headers);
                if (String(requestedId) !== String(ticketIdRef.current)) return;
                setClaritaskComments(res.data.claritask_comments || []);
            } catch (err) {
                console.error("Failed to fetch Claritask comments:", err);
            } finally {
                if (String(requestedId) === String(ticketIdRef.current)) {
                    setLoadingClaritask(false);
                }
            }
        };
        fetchClaritaskComments();
        // Only re-fetch when the ticket we're looking at actually changes (or
        // its transferred-out state flips) — NOT on every `ticket` object
        // update, since unrelated state (e.g. a live comment_seens merge)
        // creates a new `ticket` reference without affecting this at all.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket?.id, ticket?.is_transferred_out, ticketId]);

    const fetchRequestsTicketDetails = async (id, silent = false) => {
        const url = silent ? `${baseURL}ticket/${id}?silent=1` : `${baseURL}ticket/${id}`;
        const response = await axios.get(url, headers);
        return response?.data?.data;
    };

    const handleSelectTab = (key) => {
        setActiveKey(key); // forward, reply, note
        if(key == 'note') {
            setKey('note');
        }else{
            setKey('replies');
        }
    };

    const applyTicketData = (data) => {
        if (!data || String(data.id) !== String(ticketIdRef.current)) return false;
        setTicket({
            ...data,
            clientUpdated: new Date().getTime(),
        });
        setSidePanelTicketUpdate({
            id: data.id,
            title: data.title,
            subject: data.subject,
            description: data.description,
            status: data.status,
            priority: data.priority,
        });
        setTicketFound(true);
        return true;
    };

    useEffect(() => {
        setTicket(null);
        setTicketFound(true);
        setIsLoading(true);
        setClaritaskComments([]);

        const requestedId = ticketId;
        const idNum = parseInt(requestedId, 10);
        if (!isNaN(idNum)) {
            dispatch(postMarkSeenTickets([idNum]));
        }

        let cancelled = false;

        (async () => {
            try {
                const data = await fetchRequestsTicketDetails(requestedId);
                if (cancelled) return;
                if (!applyTicketData(data)) return;
            } catch (error) {
                if (cancelled || String(requestedId) !== String(ticketIdRef.current)) return;
                console.error("Failed to fetch ticket details:", error);
                if (error.response && error.response.status === 404) {
                    setTicketFound(false);
                }
            } finally {
                if (!cancelled && String(requestedId) === String(ticketIdRef.current)) {
                    setIsLoading(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [ticketId]);

    useEffect(() => {
        if (ticketId) {
            dispatch(fetchTasks(ticketId));
        }
    }, [ticketId]);

    async function handleFetchTicketDetails(cb, silent = false) {
        const requestedId = ticketId;
        setIsLoading(true);
        try {
            const data = await fetchRequestsTicketDetails(requestedId, silent);
            applyTicketData(data);
        } catch (error) {
            if (String(requestedId) !== String(ticketIdRef.current)) return;
            console.error("Failed to fetch ticket details:", error);
            if (error.response && error.response.status === 404) {
                setTicketFound(false);
            }
        } finally {
            if (String(requestedId) === String(ticketIdRef.current)) {
                setIsLoading(false);
            }
            if (cb) cb();
        }
    }

    const ticketReady = ticket && String(ticket.id) === String(ticketId);

    useEffect(() => {
        if (!ticketReady) return;
        const node = mainColRef.current;
        if (node) {
            node.scrollTop = 0;
        }
    }, [ticketId, ticketReady]);
    const handleSelectTicket = (id) => {
        const nextId = String(id);
        if (nextId !== String(ticketId)) {
            history.replace(`/ticket/${nextId}`);
        }
    };

    const showClaritaskCreate = (showModal) => {
        showModal({
            component: CreateTask,
            modalProps: {
                ticketId: String(ticketId),
            }
        })
    }
    const showClaritaskLink = (showModal) => {
        showModal({
            component: LinkTask,
            modalProps: {
                ticketId: String(ticketId),
            }
        })
    }

    const askForClarification = async () => {
        try{
            setSendingClarification(true);
            await axios.post(`${baseURL}ticket/${ticketId}/ask-clarification`, {}, headers);
            
            await handleFetchTicketDetails();
        }catch(error){
            console.error("Failed to send clarification request:", error);
        }finally{
            setSendingClarification(false);
        }
    }

        const askForConfirmation = async () => {
        try{
            setSendingConfirmation(true);
            await axios.post(`${baseURL}ticket/${ticketId}/ask-confirmation`, {}, headers);

            await handleFetchTicketDetails();
        }catch(error){
            console.error("Failed to send confirmation request:", error);
        }finally{
            setSendingConfirmation(false);
        }
    }


    if (!ticketFound) {
        return (
            <MainContainer>
                <div className="text-center mt-5">
                    <h1 className="text-danger">Ticket not found</h1>
                    <p>The ticket you are looking for does not exist or has been deleted.</p>
                    <BsFileEarmarkExcel size={50} className="mt-4 text-danger" />
                </div>
            </MainContainer>
        )
    }

    if (typeof tasks === 'undefined') {
        return <div>Undefined !</div>
    }

    return (
        <MainContainer>
            <div style={{ display: 'flex', height: 'calc(100vh - 60px)', overflow: 'hidden', position: 'fixed', top: 'var(--app-header-height)', left: 'var(--sidebar-width, 230px)', right: '0px', bottom: 0, paddingRight: '16px' }} className="ticket-details-outer ticket-details-outer--responsive">
                    {/* Side panel with slide-in transition */}
                    <div style={{
                        width: showPanel ? 'min(260px, 38vw)' : '0px',
                        minWidth: showPanel ? 'min(260px, 38vw)' : '0px',
                        overflow: 'visible',
                        transition: 'width 0.25s ease, min-width 0.25s ease',
                        flexShrink: 0,
                        position: 'relative',
                        zIndex: 21,
                    }}>
                        <div style={{ width: showPanel ? 'min(260px, 38vw)' : '0px', height: '100%', overflow: 'hidden' }}>
                            {showPanel && (
                                <TicketSidePanel
                                    currentTicketId={ticketId}
                                    onSelect={handleSelectTicket}
                                    onClose={() => togglePanel(false)}
                                    userId={user?.id}
                                    updatedTicket={sidePanelTicketUpdate}
                                />
                            )}
                        </div>

                        {/* Toggle button — anchored to the right edge of the panel, half inside / half outside */}
                        {!isCustomer && showPanel && (
                            <button
                                onClick={() => togglePanel(false)}
                                title="Close ticket list"
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '-14px',   /* half of 28px button width */
                                    zIndex: 100,
                                    width: '28px',
                                    height: '28px',
                                    borderRadius: '50%',
                                    border: '1px solid #dee2e6',
                                    background: '#fff',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    padding: 0,
                                    color: '#6c757d',
                                }}
                            >
                                <BsChevronLeft size={13} />
                            </button>
                        )}
                    </div>

                    {/* Collapsed strip with centered round button — visible only when panel is closed */}
                    {!isCustomer && !showPanel && (
                        <div
                            onClick={() => togglePanel(true)}
                            title="Open ticket list"
                            style={{
                                width: '22px',
                                minWidth: '22px',
                                height: '100%',
                                background: '#f0f2f5',
                                borderRight: '1px solid #dee2e6',
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                                paddingTop: '16px',
                                cursor: 'pointer',
                                flexShrink: 0,
                                transition: 'background 0.15s ease',
                                overflow: 'visible',
                                position: 'relative',
                                zIndex: 25,
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#e2e6ea'}
                            onMouseLeave={e => e.currentTarget.style.background = '#f0f2f5'}
                        >
                            <div style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                border: '1px solid #dee2e6',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                color: '#6c757d',
                                position: 'absolute',
                                left: '8px',
                                top: '16px',
                            }}>
                                <BsChevronRight size={13} />
                            </div>
                        </div>
                    )}


                    <div style={{ flex: 1, minWidth: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: '16px 24px 16px 20px', position: 'relative', zIndex: 20 }}>
                    {!ticketReady ?
                        <TicketDetailsSkeleton showSidebar={!isCustomer} />
                        :
                    <Row className={`py-3 ${ticketDetailsStyles.detailsRow}`}>
                        <Col sm={12} md={8} xxl={9} className={ticketDetailsStyles.mainCol} data-ticket-layout="main" ref={mainColRef}>
                            {!isCustomer && !isTransferredOut && (
                                <div className={`d-flex justify-content-end mb-2 ${ticketDetailsStyles.topBar}`}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        {isAdmin && (
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => setShowTransferModal(true)}
                                                disabled={isClosed}
                                                style={{ whiteSpace: 'nowrap' }}
                                            >
                                                Transfer Ticket
                                            </Button>
                                        )}
                                        <Button 
                                            variant="secondary"
                                            size="sm"
                                            onClick={askForClarification} 
                                            disabled={isClosed || sendingClarification} 
                                            className='ask-for-clarification-btn'
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            {sendingClarification ? 'Sending...' : 'Ask for Clarification'}
                                        </Button>
                                        <Button 
                                            variant="secondary"
                                            size="sm"
                                            onClick={askForConfirmation} 
                                            disabled={isClosed || sendingConfirmation} 
                                            className='ask-for-confirmation-btn'
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            {sendingConfirmation ? 'Sending...' : 'Ask for Confirmation'}
                                        </Button>
                                        <ActivityModal ticket={ticket} />
                                        <TicketActions reports={reports} ticket={ticket} onComplete={handleFetchTicketDetails} onMergeComplete={() => handleFetchTicketDetails(undefined, true)} onUpdate={(updated) => {
                                            setTicket(prev => ({ ...prev, ...updated }));
                                            setSidePanelTicketUpdate(prev => ({ ...prev, ...updated }));
                                        }} />
                                    </div>
                                </div>
                            )}
                            {isTransferredOut && (
                                <div className="d-flex justify-content-end mb-2 align-items-center gap-2">
                                    <ActivityModal ticket={ticket} />
                                </div>
                            )}
                            <div className={ticketDetailsStyles.ticketDescription}>
                                <Conversations ticket={ticket} type='ticket' />
                            </div>
                            {isTransferredOut ? (
                                <Alert variant="info" className="mt-3">
                                    This ticket was transferred. You can view progress only. Replies, notes, and property changes are disabled.
                                </Alert>
                            ) : isRejected ? (
                                <Alert variant="secondary" className="mt-3">
                                    This ticket is rejected. You can add replies
                                    and notes, but cannot change ticket details
                                    or forward messages.
                                </Alert>
                            ) : isClosedTicket ? (
                                <Alert variant="secondary" className="mt-3">
                                    This ticket is closed. You can add replies
                                    and notes, but cannot change ticket details
                                    or forward messages.
                                </Alert>
                            ) : null}
                            {!isTransferredOut && (
                            <div className={ticketDetailsStyles.composeSection} data-ticket-layout="compose">
                            <Tabs defaultActiveKey="reply" className='position-relative' onSelect={handleSelectTab}>
                                <Tab eventKey="reply" title={<><BsReply className="me-1 mb-1" size={15} /> Reply</>}>
                                    <Comment type="reply" activeKey={activeKey} ticket={ticket} onCommentAdded={(comment) => {
                                        setTicket(prev => ({ ...prev, replies: [comment, ...(prev.replies ?? [])] }));
                                    }} />
                                </Tab>
                                {!isCustomer && !isClosed && (
                                <Tab eventKey="forward" title={<><BsReply className="me-1 mb-1 flip-icon" size={15} /> Forward</>}>
                                    <Comment type="forward" activeKey={activeKey} ticket={ticket} onCommentAdded={(comment) => {
                                        setTicket(prev => ({ ...prev, replies: [comment, ...(prev.replies ?? [])] }));
                                    }} />
                                </Tab>
                                )}
                                {!isCustomer && (
                                    <Tab eventKey="note" title={<><BsFileEarmarkText className="me-1 mb-1" size={15} /> Add Note</>}>
                                        <Comment type="note" activeKey={activeKey} ticket={ticket} onCommentAdded={(comment) => {
                                            setTicket(prev => ({ ...prev, notes: [comment, ...(prev.notes ?? [])] }));
                                        }} />
                                    </Tab>
                                )}
                            </Tabs>
                            </div>
                            )}

                            <div className={ticketDetailsStyles.threadTabs} data-ticket-layout="threads">
                            <Tabs
                                activeKey={isCustomer ? 'replies' : key}
                                onSelect={(k) => setKey(k)}
                            >
                                <Tab eventKey="replies" title={<><BsChatText className="me-1 mb-1" size={15} /> Conversations</>}>
                                    <Conversations ticket={ticket} type='replies' isActive={isCustomer || key === 'replies'} />
                                </Tab>

                                {!isCustomer && (
                                    <Tab eventKey="note" title={<><BsFileEarmarkText className="me-1 mb-1" size={15} /> Notes</>}>
                                        <Conversations ticket={ticket} type='notes' isActive={key === 'note'} onChange={(updatedNote) => {
                                            if (ticket?.is_transferred_out) return;
                                            if (updatedNote?.id) {
                                                setTicket(prev => ({
                                                    ...prev,
                                                    notes: (prev.notes ?? []).map(n => n.id === updatedNote.id ? updatedNote : n)
                                                }));
                                            } else {
                                                handleFetchTicketDetails();
                                            }
                                        }} />
                                    </Tab>
                                )}
                                {!isCustomer && !isTransferredOut && (
                                    <Tab eventKey="claritask" title={
                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                            <BsFileEarmarkText className="me-1 mb-1" size={15} /> Claritask Comments
                                            {loadingClaritask ? (
                                                <span className="badge ms-1" style={{ fontSize: '0.7em', backgroundColor: '#c8edf8', color: 'transparent', minWidth: 18, borderRadius: 10, display: 'inline-block', animation: 'pulse-badge 1.2s ease-in-out infinite' }}>&nbsp;&nbsp;&nbsp;</span>
                                            ) : claritaskComments.length > 0 && (
                                                <span className="badge ms-1" style={{ fontSize: '0.7em', backgroundColor: '#18AEE3', color: '#fff' }}>{claritaskComments.length}</span>
                                            )}
                                        </span>}>
                                        {loadingClaritask ? (
                                            <Spinner animation="border" size="sm" />
                                            ) : (
                                            <Conversations
                                                ticket={{ ...ticket, claritask: claritaskComments }}
                                                type="claritask"
                                                isActive={key === 'claritask'}
                                            />
                                        )}
                                    </Tab>
                                )}
                                {!isCustomer && !isTransferredOut && (
                                    <Tab 
                                    eventKey="linked-claritask" 
                                    title={
                                        <span 
                                            style={{display:'inline-flex',alignItems:'center',gap:4}}
                                        >
                                            <img src="/images/claritasklogo.svg" alt="claritask" style={{width:14,height:14}} /> 
                                            Linked Claritask {linkedTasksLoading ? (
                                                <span className="badge ms-1" style={{fontSize:'0.7em',backgroundColor:'#c8edf8',color:'transparent',minWidth:18,borderRadius:10,display:'inline-block',animation:'pulse-badge 1.2s ease-in-out infinite'}}>&nbsp;&nbsp;&nbsp;</span>
                                            ) : tmpTasks.length > 0 && (
                                                <span className="badge ms-1" style={{fontSize:'0.7em',backgroundColor:'#18AEE3',color:'#fff'}}>{tmpTasks.length}</span>
                                            )}
                                        </span>}>
                                        <div className={ticketDetailsStyles.tabScrollFallback}>
                                            <LinkedClaritaskTab
                                                ticketId={ticketId}
                                                tasks={tmpTasks}
                                                tasksLoading={linkedTasksLoading}
                                                showClaritaskCreate={showClaritaskCreate}
                                                showClaritaskLink={showClaritaskLink}
                                                user={user}
                                            />
                                        </div>
                                    </Tab>
                                )}
                            </Tabs>
                            </div>

                        </Col>
                        <Col sm={12} md={4} xxl={3} className={ticketDetailsStyles.sidebarCol} style={{ paddingLeft: '12px' }}>
                            <Accordion defaultActiveKey={['0']} alwaysOpen>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <BsTags className="me-2" size={18} /> Ticket Properties
                                    </Accordion.Header>
                                    <Accordion.Body className='text-start ticket-properties'>
                                        <TicketProperties ticket={ticket} ticketIsLoading={isLoading} onUpdate={(updated) => {
                                            setTicket(prev => ({ ...prev, ...updated }));
                                            setSidePanelTicketUpdate(prev => ({ ...prev, ...updated }));
                                        }} onComplete={handleFetchTicketDetails} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                {!isCustomer && !isTransferredOut && (
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <BsClock className="me-2" size={18} /> Time Logs
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <TimerWatch ticket={ticket} setTicket={setTicket} />
                                        <div style={{ maxHeight: 400, overflowY: 'auto', paddingRight: 7 }}>
                                            {(ticket.ticket_timer && ticket.ticket_timer.length > 0) ? ticket.ticket_timer.map(time => <Time setTicket={setTicket} key={time.id} time={time} details={ticket} />) : ''}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                )}
                            </Accordion>
                        </Col>
                    </Row>
                    }
                        </div>
                    </div>
            <TransferTicketModal
                show={showTransferModal}
                onHide={() => setShowTransferModal(false)}
                ticket={ticket}
                onTransferred={() => history.push('/tickets/transferred')}
            />
        </MainContainer>
    )
}

export default TicketDetails;
